module.exports = __webpack_public_path__ + "static/img/proposition_content3.20e08f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/proposition_content3.png
// module id = fjja
// module chunks = 0